import { Injectable, NgModule } from '@angular/core';
import { CommonModule, TranslationWidth } from '@angular/common';
import { CaptchaComponent } from './captcha/captcha.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CustomCaptchaComponent } from './custom-captcha/custom-captcha.component';
import { HttpService } from './services/http.service';
import {
  NgbCalendar,
  NgbCalendarPersian,
  NgbDatepickerI18n,
  NgbDateStruct,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';

const WEEKDAYS_LABEL = ['دو‌شنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه', 'شنبه', 'یکشنبه'];
const MONTHS = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
];

@Injectable()
export class NgbDatepickerI18nPersian extends NgbDatepickerI18n {
  getWeekdayLabel(weekday: number) {
    return WEEKDAYS_LABEL[weekday - 1];
  }
  getMonthShortName(month: number) {
    return MONTHS[month - 1];
  }
  getMonthFullName(month: number) {
    return MONTHS[month - 1];
  }
  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.year}-${this.getMonthFullName(date.month)}-${date.day}`;
  }
}

const modules = [
  CarouselModule,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
  NgbModule,
];

const components = [CaptchaComponent, CustomCaptchaComponent];

@NgModule({
  declarations: [...components],
  imports: [CommonModule, ...modules],
  exports: [...components, ...modules],
  providers: [
    HttpService,
    { provide: NgbCalendar, useClass: NgbCalendarPersian },
    { provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nPersian },
  ],
})
export class SharedModule {}
